import { useBootstrapTheme } from "../../contexts/BootstrapThemeContext";
import { EffectThemeTextareaProps } from "../../types/effectTheme";

const EffectThemeTextarea = ({
  textareaClass,
  style,
  ...props
}: EffectThemeTextareaProps) => {
  const { effectiveTheme } = useBootstrapTheme();
  const isDark = effectiveTheme === "dark";

  const baseStyle: React.CSSProperties = {
    width: "100%",
    minHeight: "120px",
    resize: "vertical",

    padding: "0.75rem 0.9rem",
    borderRadius: "0.6rem",
    outline: "none",

    backdropFilter: "blur(10px)",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease",

    color: isDark ? "rgba(226, 232, 240, 0.95)" : "rgba(15, 23, 42, 0.95)",

    background: isDark
      ? "linear-gradient(145deg, rgba(20, 38, 80, 0.40) 0%, rgba(15, 23, 42, 0.55) 60%, rgba(30, 41, 59, 0.45) 100%)"
      : "linear-gradient(145deg, rgba(255, 255, 255, 0.80) 0%, rgba(248, 250, 252, 0.90) 60%, rgba(241, 245, 249, 0.85) 100%)",

    border: isDark
      ? "1px solid rgba(96, 165, 250, 0.28)"
      : "1px solid rgba(59, 130, 246, 0.18)",

    boxShadow: isDark
      ? "0 8px 24px rgba(59, 130, 246, 0.08), inset 0 1px 0 rgba(255,255,255,0.04)"
      : "0 8px 24px rgba(2, 6, 23, 0.05), inset 0 1px 0 rgba(255,255,255,0.45)",

    opacity: props.disabled ? 0.6 : 1,
    cursor: props.disabled ? "not-allowed" : "text",
  };

  const focusBorder = isDark
    ? "1px solid rgba(96, 165, 250, 0.55)"
    : "1px solid rgba(59, 130, 246, 0.45)";

  const focusShadow = isDark
    ? "0 10px 30px rgba(96, 165, 250, 0.16), 0 0 0 3px rgba(59, 130, 246, 0.18)"
    : "0 10px 30px rgba(59, 130, 246, 0.14), 0 0 0 3px rgba(59, 130, 246, 0.12)";

  return (
    <textarea
      {...props}
      className={textareaClass ?? "form-control"}
      style={{ ...baseStyle, ...style }}
      onFocus={(e) => {
        e.currentTarget.style.border = focusBorder;
        e.currentTarget.style.boxShadow = focusShadow;
        e.currentTarget.style.transform = "translateY(-1px)";
        props.onFocus?.(e);
      }}
      onBlur={(e) => {
        e.currentTarget.style.border = baseStyle.border as string;
        e.currentTarget.style.boxShadow = baseStyle.boxShadow as string;
        e.currentTarget.style.transform = "translateY(0)";
        props.onBlur?.(e);
      }}
    />
  );
};

export default EffectThemeTextarea;
